import { render, staticRenderFns } from "./FundNavChartChrome.vue?vue&type=template&id=5457d52c&scoped=true&"
import script from "./FundNavChartChrome.vue?vue&type=script&lang=js&"
export * from "./FundNavChartChrome.vue?vue&type=script&lang=js&"
import style0 from "./FundNavChartChrome.vue?vue&type=style&index=0&id=5457d52c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457d52c",
  null
  
)

export default component.exports